import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { JSX } from 'react';
import { t } from '../../../../types/translation/Translator';
import { StockLocation } from '../../../../types/stock_location/stockLocation';
import { MessageQuestionCircleIcon } from '../../../icons/MessageQuestionCircle/MessageQuestionCircleIcon';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { OrderTypeFilterDropdownContent, OrderTypeFilterInnerContent } from './DropdownContent';
import { OrderUtil } from '../../../../types/order';
import { itemsContainText } from '../../../../util/string.util';
import { TableSettings } from '../../../../types/table_settings/TableSettings';
import { FlowType } from '../../../../types/order/orderFlow';

export class OrderTypeFilter extends BaseFilter<FlowType> {
  filteredStockLocations: Map<string, StockLocation>;
  tableSettings: TableSettings<any>;

  constructor(filteredStockLocations: Map<string, StockLocation>, tableSettings: TableSettings<any>) {
    super();
    this.filteredStockLocations = filteredStockLocations;
    this.tableSettings = tableSettings;
  }

  toLabel(): string {
    return t(TranslationKey.orderType).singular.label;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.orderType?.size || 0;
  }

  toIcon(): JSX.Element {
    return <MessageQuestionCircleIcon className={this.className} />;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return (
      <OrderTypeFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <OrderTypeFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  search(item: FlowType, query: string): boolean {
    return itemsContainText(query, [item, OrderUtil.typeToString(item)]);
  }
}
